import customerManagements from "./customerManagements";
import customerRawMaterials from "./customerRawMaterials";
import inspections from "./inspections";

const customerManagementService = [
    {
        matcher: 'customerManagements',
        reply: config => {
            return [200, customerManagements];
        }
    },
    {
        matcher: /customerManagements\/(.*)/,
        reply: config => {
            const id = /customerManagements\/(.*)/.exec(config.url)[1];
            const data = customerManagements.find(item => item.uuid === id);
            return [200, data];
        }
    },
    {
        matcher: 'customerManagement/customerRawMaterials',
        reply: config => {
            return [200, customerRawMaterials];
        }
    },
    {
        matcher: 'customerManagement/inspections',
        reply: config => {
            return [200, inspections];
        }
    },
]

export default customerManagementService;